/**
 * A no-operation function that does nothing.
 * Use as a stable default for callback props to avoid creating new function references on each render.
 */
export const noop = () => {}
